import React, { useState } from "react"
import Box from "@material-ui/core/Box"
import Checkbox from "components/Forms/Checkbox"

/** Styles */
import styles from "./styles"

interface Props {
  handleUpdate: Function
  data: any
}

const Announcement: React.FC<Props> = ({ handleUpdate, data }) => {
  const { category, section } = styles()
  const [title] = useState("dashboard")

  return (
    <Box display="flex" alignItems="center" className={section}>
      <Box flex="3" className={category}>
        {title}
      </Box>
      <Box flex="1">
        {/* View */}
        <Checkbox
          label={null}
          value={Boolean(data?.dashboard_view)}
          onChange={() =>
            handleUpdate("dashboard_view", Boolean(!data?.dashboard_view))}
        />
      </Box>
      <Box flex="1" />
      <Box flex="1" />
      <Box flex="1" />
    </Box>
  )
}
export default Announcement
